module.exports = __webpack_public_path__ + "gin_ios_qr.44b641b.png";